import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationLink = _resolveComponent("NavigationLink")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_AppBase = _resolveComponent("AppBase")

  return (_openBlock(), _createBlock(_component_AppBase, null, {
    navigation: _withCtx(() => [
      _createVNode(_component_Navigation, null, {
        default: _withCtx(() => [
          (_ctx.$page.props.auth.user)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.routes, (route) => {
                return (_openBlock(), _createBlock(_component_NavigationLink, {
                  key: route.title,
                  "href-route": route.hrefRoute,
                  href: route.href,
                  "page-route": route.pageRoute,
                  title: route.title,
                  "not-a-link": route.notALink,
                  "inertia-link-obj": route.inertiaLinkObj
                }, null, 8, ["href-route", "href", "page-route", "title", "not-a-link", "inertia-link-obj"]))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 1
  }))
}